import { motion } from "framer-motion";
import { CONTACT } from "../lib/brand";
import { IconWhatsApp, IconInstagram, IconMapPin } from "./icons";

const CHANNELS = [
  {
    key: "whatsapp",
    href: CONTACT.whatsapp,
    label: "WhatsApp",
    caption: "Conversa direta",
    Icon: IconWhatsApp,
  },
  {
    key: "instagram",
    href: CONTACT.instagram,
    label: "Instagram",
    caption: "Diário editorial",
    Icon: IconInstagram,
  },
  {
    key: "localizacao",
    href: CONTACT.maps,
    label: "Localização",
    caption: `${CONTACT.address.street} · ${CONTACT.address.neighborhood}`,
    Icon: IconMapPin,
  },
];

export default function Contato() {
  return (
    <section
      id="contato"
      data-testid="contato-section"
      className="relative bg-brick-500 text-cream py-24 sm:py-40 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-x-0 -bottom-20 sm:-bottom-32 pointer-events-none select-none flex justify-center opacity-15"
      >
        <span
          className="font-serif italic leading-none"
          style={{ fontSize: "clamp(10rem, 32vw, 40rem)" }}
        >
          herida
        </span>
      </div>

      <div className="relative mx-auto max-w-[1600px] px-6 sm:px-10">
        <div className="grid grid-cols-12 gap-6 lg:gap-16 items-start">
          <div className="col-span-12 lg:col-span-6">
            <div className="flex items-center gap-4 font-mono text-[10px] uppercase tracking-[0.3em] text-cream/80 mb-8">
              <span className="w-8 h-px bg-cream/60" />
              <span>Cap. Final — Contato</span>
            </div>

            <h2
              className="font-serif leading-[0.9] tracking-tight text-cream"
              style={{ fontSize: "clamp(3rem, 7.5vw, 8rem)" }}
              data-testid="contato-title"
            >
              Vamos <br />
              <span className="italic-serif">reescrever</span> <br />
              seu armário?
            </h2>

            <p className="mt-10 font-sans text-base sm:text-lg leading-relaxed text-cream/85 max-w-md">
              Toda conversa acontece pessoalmente comigo.
              Escolha por onde prefere começar.
            </p>
          </div>

          <div className="col-span-12 lg:col-span-6 flex flex-col gap-4 sm:gap-5 lg:mt-4">
            {CHANNELS.map((c, i) => (
              <motion.a
                key={c.key}
                href={c.href}
                target="_blank"
                rel="noreferrer"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-15% 0px" }}
                transition={{
                  duration: 0.7,
                  delay: 0.15 + i * 0.12,
                  ease: [0.22, 1, 0.36, 1],
                }}
                whileHover={{ x: 10 }}
                data-testid={`contact-channel-${c.key}`}
                className="group relative flex items-center justify-between gap-6 border border-cream/25 hover:border-cream bg-transparent hover:bg-cream/5 transition-colors duration-500 px-6 sm:px-8 py-6 sm:py-8"
              >
                <span className="flex items-center gap-6 sm:gap-8">
                  <span className="w-14 h-14 sm:w-16 sm:h-16 border border-cream/30 group-hover:border-cream group-hover:bg-cream group-hover:text-brick-500 flex items-center justify-center text-cream transition-colors duration-500">
                    <c.Icon size={28} strokeWidth={1.5} />
                  </span>
                  <span className="flex flex-col">
                    <span
                      className="font-serif italic text-cream leading-none"
                      style={{ fontSize: "clamp(1.75rem, 3vw, 2.5rem)" }}
                    >
                      {c.label}
                    </span>
                    <span className="mt-2 font-mono text-[10px] uppercase tracking-[0.3em] text-cream/70">
                      {c.caption}
                    </span>
                  </span>
                </span>
                <span className="hidden sm:inline font-serif italic text-3xl text-cream/60 group-hover:text-cream transition-colors duration-500">
                  →
                </span>
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
